<template>
  <NuxtLayout navbar-color="#f3f4f6">
    <div v-if="story">
      <StoryblokComponent
        v-for="hero in story.content.hero"
        :key="hero._uid"
        :blok="hero"
      />
      <StoryblokComponent
        v-for="body in story.content.body"
        :key="body._uid"
        :blok="body"
      />
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
const { slug } = useRoute().params
const { story } = await useFetchStory(`webinars/${slug}`, {
  additionalValidation: (story) => {
    return story.content.disable_page_generation
  },
}).catch((error) => {
  throw createError({
    message: error,
    statusCode: 404,
  })
})
const mainStore = useMainStore()

definePageMeta({
  key: (route) => route.fullPath,
})

onMounted(() => {
  mainStore.$patch({
    storyData: story.value,
  })
})
useCustomHead(story)
</script>
